import GoogleAdwordsProductCard from '@reaffiliates/GoogleAdwords/GoogleAdwordsProductCard';
import GemiusProductCard from '@reaffiliates/Gemius/GemiusProductCard';
import PinterestProductCard from '@reaffiliates/Pinterest/PinterestProductCard';
import RTBHouseProductCard from '@reaffiliates/RTBHouse/RTBHouseProductCard';
import TikTokProductCard from '@reaffiliates/TikTok/TikTokProductCard';
import WPpixelProductCard from '@reaffiliates/WPpixel/WPpixelProductCard';
import GoogleTagManagerViewItem from '@reaffiliates/GoogleTagManager/GoogleTagManagerViewItem';
import { IMarketingCategory } from '@features/productPreview/typescript';
const ReaffiliatesProductCard = async (productID: number, productName: string, productPrice: string, categories: Array<IMarketingCategory>, brand: string | undefined) => {
  GoogleTagManagerViewItem(productID, productName, productPrice, categories, brand);
  GoogleAdwordsProductCard(productID, productName, productPrice);
  GemiusProductCard();
  PinterestProductCard(productID, productName, productPrice);
  RTBHouseProductCard(productID, productName, productPrice);
  TikTokProductCard(productID, productName);
  WPpixelProductCard(productID, productName, productPrice);
};
export default ReaffiliatesProductCard;